import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import Navbar from "./navbar";
import Home from "./home.js";
import Create from "./create.js";
import Deposit from "./deposit.js";
import Withdraw from "./withdraw.js";
import AllData from "./alldata.js";
import userContext from "./context";

export default function App() {
  const [users, setUsers] = useState([
    {
      name: "Aravinth",
      email: "aravinth@gmail.com",
      password: "password123",
      balance: 1000,
    },
  ]);

  return (
    <HashRouter>
  <userContext.Provider value={{ users, setUsers }}>
    <Navbar />

    <Routes>
  {/* This forces the empty white screen to redirect to Home */}
  <Route path="/" element={<Navigate to="/home" replace />} />
  
  <Route path="/home" element={<Home />} />
  <Route path="/create" element={<Create />} />
  <Route path="/deposit" element={<Deposit />} />
  <Route path="/withdraw" element={<Withdraw />} />
  <Route path="/alldata" element={<AllData />} />
</Routes>
  </userContext.Provider>
</HashRouter>
  );
}
